import { axiosInstanceWebsite } from "../instance";

export interface DropiIntegrationInterface {
    integration_token: string;
    is_active: boolean;
}

export interface MastershopIntegrationInterface {
    api_key: string;
    is_active: boolean;
    connected?: boolean;
}

export const getDropiIntegrations = async () => {
    const response = await axiosInstanceWebsite.get(`/order/dropi/integration`);
    return response.data;
};

export const postDropiIntegration = async (data: DropiIntegrationInterface) => {
    const response = await axiosInstanceWebsite.post(`/order/dropi/integration`, data);
    return response.data;
};

export const getMastershopIntegrations = async () => {
    const response = await axiosInstanceWebsite.get(`/order/mastershop/integration`);
    return response.data;
};

export const postMastershopIntegration = async (data: MastershopIntegrationInterface) => {
    const response = await axiosInstanceWebsite.post(`/order/mastershop/integration`, data);
    return response.data;
};

export interface ShopifyConnectionInterface {
    id: number;
    label: string;
    url_store: string;
    client_id?: string | null;
    connected: boolean;
    granted_scopes: string[];
    missing_scopes: string[];
    funnels_count?: number;
    validated_at?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
}

export const getShopifyConnections = async (): Promise<ShopifyConnectionInterface[]> => {
    const response = await axiosInstanceWebsite.get(`/websites/shopify-connections`);
    return response.data;
};

export const deleteShopifyConnection = async (id: number): Promise<void> => {
    await axiosInstanceWebsite.delete(`/websites/shopify-connections/${id}`);
};

export interface UpsertShopifyConnectionPayload {
    label?: string | null;
    url_store: string;
    token?: string | null;
}

export const upsertShopifyConnection = async (
    payload: UpsertShopifyConnectionPayload
): Promise<ShopifyConnectionInterface> => {
    const response = await axiosInstanceWebsite.post(`/websites/shopify-connections`, payload);
    return response.data;
};

export const validateShopifyConnection = async (
    id: number
): Promise<ShopifyConnectionInterface> => {
    const response = await axiosInstanceWebsite.post(`/websites/shopify-connections/${id}/validate`);
    return response.data;
};

export interface ShopifyConnectionOAuthPayload {
    url_store?: string;
    client_id?: string;
    client_secret?: string;
    label?: string | null;
}

export interface ShopifyConnectionOAuthStart {
    connection_id: number;
    authorization_url: string;
}

// Inicia el OAuth de una conexión (Client ID/Secret). Si se pasa id, reconecta una existente
// (usa las credenciales guardadas si no se re-envían); si no, crea/registra una nueva.
export const startShopifyConnectionOAuth = async (
    payload: ShopifyConnectionOAuthPayload,
    connectionId?: number
): Promise<ShopifyConnectionOAuthStart> => {
    const path = connectionId
        ? `/websites/shopify-connections/${connectionId}/oauth-url`
        : `/websites/shopify-connections/oauth-url`;
    const response = await axiosInstanceWebsite.post(path, payload);
    return response.data;
};

export const updateShopifyConnection = async (
    id: number,
    payload: UpsertShopifyConnectionPayload
): Promise<ShopifyConnectionInterface> => {
    const response = await axiosInstanceWebsite.put(`/websites/shopify-connections/${id}`, payload);
    return response.data;
};

export const getIntegrationsAvailability = async () => {
    const response = await axiosInstanceWebsite.get(`/integrations/availability`);
    return response.data;
};
